import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Text from '@adsk/bim360-matrix-react-text';
import A from '@adsk/bim360-matrix-react-a';

import './_SwitcherMenu.scss';

const tickImg = () => (
  <svg
    className="SwitcherMenu__tick-icon"
    width="9px"
    height="7px"
    viewBox="0 0 9 7"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-682.000000, -216.000000)" fill="#FFFFFF">
        <g transform="translate(447.000000, 104.000000)">
          <path d="M242.550445,112.247068 L238.181228,116.422756 L236.420393,114.981813 C236.057809,114.660497 235.499704,114.704895 235.192902,115.079717 C234.886101,115.455392 234.952698,116.010082 235.339757,116.302653 L237.687728,118.22372 C238.021282,118.493808 238.504821,118.473886 238.815038,118.177045 L243.72443,113.481105 C244.296766,112.950606 243.917675,111.993488 243.137296,112.000033 C242.917298,112.003449 242.707261,112.092529 242.550445,112.247068 Z" />
        </g>
      </g>
    </g>
  </svg>
);

/**
 * A switcher menu for handling header menu items
 **/
class SwitcherMenu extends Component {
  /**
   * Constructor
   */
  constructor(props) {
    super(props);
  }

  /**
   * @returns {VDOM}
   **/
  renderMenuItems() {
    const isSelectedItem = item => item.id === this.props.selectedItem.id;

    const _handleOnTabClick = (event, item) => {
      if (item.onClick || this.props.onSelect) {
        // ctrl+click or cmd+click should have default behavior of anchor link
        if (event.ctrlKey || event.metaKey) return;

        event.preventDefault();

        if (item.onClick) {
          item.onClick(this.props.selectedItem);
        } else {
          this.props.onSelect(item);
        }
      }
    };

    return this.props.menuItems.map(item => {
      const itemClasses = classNames('SwitcherMenu__menu-item', {
        'SwitcherMenu__menu-item--selected': isSelectedItem(item)
      });
      const itemNameClasses = classNames('SwitcherMenu__menu-item--name', {
        'SwitcherMenu__menu-item--name-selected': isSelectedItem(item)
      });

      const url = item.url && typeof item.url === 'function' ? item.url() : item.url;
      return (
        <A
          key={item.id}
          className={itemClasses}
          href={url}
          target={url && '_blank'}
          onClick={event => _handleOnTabClick(event, item)}
        >
          <Text className={itemNameClasses}>{item.name}</Text>
          {isSelectedItem(item) && <span>{tickImg()}</span>}
        </A>
      );
    });
  }

  /**
   * Render
   * @returns {VDOM}
   **/
  render() {
    const classes = classNames('SwitcherMenu', this.props.className);

    return (
      <div className={classes} style={this.props.customStyle}>
        <div className="SwitcherMenu__menu">{this.renderMenuItems()}</div>
      </div>
    );
  }
}

SwitcherMenu.propTypes = {
  /**
   * A custom className for the component container
   */
  className: PropTypes.string,
  /**
   * Custom style object for the component container
   */
  customStyle: PropTypes.object,
  /**
   * Collection of menu items
   */
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      url: PropTypes.string
    })
  ).isRequired,
  /**
   * A callback event for the selection of a menu item
   */
  onSelect: PropTypes.func,
  /**
   * Selected menu item
   */
  selectedItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    url: PropTypes.string
  }).isRequired
};

export default SwitcherMenu;
